/* jshint node:true */
'use strict';

var React = require('react');

var TeamStats = React.createClass({

    displayName: 'TeamStats',

    render: function () {

        var aStats      = this.props.stats || [];

        if(aStats.length != 4){
            return null;
        }

        var rBoxStats = [];
        var iStatLen = aStats.length;
        for (var i = 0; i < iStatLen; i++) {
            rBoxStats.push(
                <TeamStatsBox key={i} data={aStats[i]} />
            );
        }

        return (
            <div className="sub-module team-statistics rugby">
            	<header className="bordered"><h1>Team Stats</h1></header>
            	<div className="content">
            		<ul className="stat-box-container">
            		    {rBoxStats}
            		</ul>
            	</div>
            </div>
        );

        //<footer>
    	//	<a href="#">Full Team Stats</a>
    	//</footer>
    }
});

var TeamStatsBox = React.createClass({

    displayName: 'TeamStatsBox',

    render: function () {

        var oStats      = this.props.data || [];
        var iMaxValue   = 0;

        if(iMaxValue < oStats.home.value){
            iMaxValue = oStats.home.value;
        }

        if(iMaxValue < oStats.away.value){
            iMaxValue = oStats.away.value;
        }

        var iHomePerc = parseInt((oStats.home.value/iMaxValue)*100);
        var iAwayPerc = parseInt((oStats.away.value/iMaxValue)*100);

        return (
			<li className="stat-box">
				<h3>{oStats.name}</h3>
                <ul className="compareLineGraph">
                    <li>
                        <span className="chartLabel">{oStats.home.abbreviation}</span>
                        <span style={{backgroundColor:'#f2f2f2'}} className="bar-total">
                            <span style={{backgroundColor:oStats.home.color,width:iHomePerc+'%'}} className="bar-percentage"></span>
                        </span>
                        <span className="chartValue">{oStats.home.displayValue}</span>
                    </li>
                    <li>
                        <span style={{backgroundColor:'#f2f2f2'}} className="bar-total">
                            <span style={{backgroundColor:oStats.away.color,width:iAwayPerc+'%'}} className="bar-percentage"></span>
                        </span>
                        <span className="chartValue">{oStats.away.displayValue}</span>
                        <span className="chartLabel clear">{oStats.away.abbreviation}</span>
                    </li>
                </ul>
			</li>
        );
    }
});

module.exports = TeamStats;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TeamStats.jsx
 **/